import { Component, OnInit } from '@angular/core';
import { PimProductBasicInfoComponent } from 'gung-standard';

@Component({
    selector: 'car-liner-pim-product-basic-info',
    templateUrl: './car-liner-pim-product-basic-info.component.html',
    styleUrls: ['./car-liner-pim-product-basic-info.component.scss'],
    standalone: false
})
export class CarLinerPimProductBasicInfoComponent extends PimProductBasicInfoComponent {
  inputOEM = '';

  removeOption(id: string) {
    const allOEM = this.pimProduct.extra.pim.OEM.split(',');

    const indexToRemove = allOEM.findIndex(itemId => itemId === id);
    if (indexToRemove > -1) {
      allOEM.splice(indexToRemove, 1);
    }

    this.pimProduct.extra.pim.OEM = allOEM.join(',');
  }

  addOption(oemString: string) {

    if (oemString === '' || ( this.pimProduct.extra?.pim?.OEM && this.pimProduct.extra.pim.OEM.split(',').includes(oemString))) {
      return;
    }

    if (!this.pimProduct.extra.pim.OEM) {
      this.pimProduct.extra.pim.OEM = oemString;
    } else {
      if (this.pimProduct.extra.pim.OEM.split(',').indexOf(oemString) < 0) {
        this.pimProduct.extra.pim.OEM += ',' + oemString;
      }
    }

    this.inputOEM = '';
  }
}